// extracted by mini-css-extract-plugin
export var active = "_fi-7";
export var blink = "_fi-8";
export var dropDownSelector = "_fi-4";
export var dropDownWrapper = "_fi-3";
export var fakeCursor = "_fi-6";
export var fontSizeButton = "_fi-9";
export var formQuillEditor = "_fi-0";
export var pressed = "_fi-a";
export var qlBlank = "_fi-1";
export var textFormattingToolbar = "_fi-2";
export var textToolbarOption = "_fi-5";